<twc-popup type="primary" caption="{{'PERMISSION_DIALOG.VIEW_GROUP_MEMBERS' | translate}}" width="l"
    #groupMemberListPopup>
    <twc-popup-content>

        <div class="twc-form">
            <div class="twc-form-control">
                <label for="firstName" class="twc-form-label"> {{'PERMISSION_DIALOG.GROUP' | translate}} </label>
                <div class="twc-form-element">
                    <input class="twc-input" [ngModel]="permissionsEditorService.selectedGroup?.name" [disabled]="true">
                </div>
            </div>
        </div>

        <div class="twc-row twc-mt-3">
            <div class="twc-col-12">
                <twc-list class="permissions-element-list">
                    <twc-list-item *ngFor="let userId of userList"
                        [ngClass]="{'selected-row': isSelectedUserId(userId)}" (click)="onSelect(userId)">
                        <div class="twc-list-item-col-1" [ngClass]="{'user-already-added': isUserAlreadyAdded(userId)}">
                            {{getUserNameById(userId)}}
                        </div>
                    </twc-list-item>
                </twc-list>
            </div>
        </div>
    </twc-popup-content>

    <twc-popup-footer class="twc-mt-3">
        <button class="twc-button twc-button-link" (click)="closePopup()">
            {{'GENERAL.CLOSE' | translate}}
        </button>
        <button class="twc-button twc-ml-2 twc-button-primary" (click)="addOverrides()" [disabled]="!selectedUsers.length">
            {{'PERMISSION_DIALOG.ADD_USER_OVERRIDES' | translate}}
        </button>
    </twc-popup-footer>

</twc-popup>